import React from 'react';

const AxonIcon = ({ size = 16, color = 'currentColor', className = '' }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        className={className}
        style={{ flexShrink: 0 }}
    >
        {/* Cell body (soma) */}
        <circle cx="8" cy="12" r="3.5" fill={color} opacity="0.15" />
        <circle cx="8" cy="12" r="2.5" fill={color} opacity="0.9" />

        {/* Dendrites (branching inputs) */}
        <path
            d="M5.5 10.5L3 8M5.5 13.5L3 16M6 9L4.5 6"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
        />

        {/* Axon (long projection) */}
        <path
            d="M11 12H19"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
        />

        {/* Myelin sheaths (segments along axon) */}
        <rect x="12.5" y="10.5" width="1.5" height="3" fill={color} opacity="0.6" rx="0.5" />
        <rect x="15.5" y="10.5" width="1.5" height="3" fill={color} opacity="0.6" rx="0.5" />

        {/* Axon terminals (branching outputs) */}
        <path
            d="M19 12L21 10.5M19 12L21 13.5"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
        />
    </svg>
);

export default AxonIcon;
